import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import { ITip } from '../../models/tips'
import { logout, refreshSession } from '../actions/constants'

export interface ITipsState {
  tips: ITip[]
}

const initialState: ITipsState = {
  tips: []
}

export const tipsSlice = createSlice({
  name: 'tips',
  initialState,
  reducers: {
    setTips: (state, action: PayloadAction<ITip[]>) => {
      state.tips = action.payload
    }
  },
  extraReducers: (builder) => {
    builder.addCase(logout, () => initialState)
      .addCase(refreshSession, () => initialState)
  }
})

export const {
  setTips
} = tipsSlice.actions

export default tipsSlice.reducer
